import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowForwardRounded } from '@mui/icons-material';
import { get_z3k_object_state } from 'z3k-config';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { formatTemp } from 'utils';
export const CircuitSetPointIndicator = memo(function CircuitSetPointIndicator(props) {
    const { heating_circuit, z3k_state } = props;
    if (!heating_circuit.id) {
        return null;
    }
    const hc_state = get_z3k_object_state(z3k_state, heating_circuit.id);
    if (!hc_state) {
        return null;
    }
    const { setpoint_temp } = hc_state;
    return (_jsxs(Box, { display: "flex", alignItems: "center", columnGap: "2px", "data-tooltip": "set-point-status-temp", children: [_jsx(ResponsiveIcon, { Icon: ArrowForwardRounded, color: "inherit", fontSize: "0.6em" }), _jsx(Typography, { component: "span", fontSize: "0.6em", children: setpoint_temp != null ? formatTemp(setpoint_temp) : '??' })] }));
});
